(() => {
    angular 
        .module('app')
        .controller('corporate.views.subsidiaryDepartments.viewHistory', 
            SubsidiaryDepartmentViewHistoryController
        );
    
    SubsidiaryDepartmentViewHistoryController.$inject = [
        '$stateParams',
        'abp.services.app.subsidiaryDepartment',
        'moment',
    ];

    function SubsidiaryDepartmentViewHistoryController(
        $stateParams,
        subsidiaryDepartmentSvc,
        moment
    ) {
        const vm = this;

        vm.loading = 0;
        vm.departmentName = $stateParams.name;
        vm.historyItems = [];

        const codeMirrorOptions = {
            lineNumbers: false,
            readOnly: true,
            mode: { name: 'javascript', json: true },
            highlightDifferences: true,
            connect: true,
            collapseIdentical: false,
            revertButtons: false,
            autoRefresh: true,
        };

        init();

        function init() {
            loadDepartmentHistory();
        }

        function loadDepartmentHistory() {
            vm.loading += 1;

            const payload = {
                id: $stateParams.id,
            }

            subsidiaryDepartmentSvc
                .getDepartmentHistory(payload)
                .success((data) => {
                    processHistoryItems(data.items);
                vm.historyItems = data.items;
                })
                .finally(() => {
                vm.loading -= 1;
                });
        }

        function processHistoryItems(items) {
            _.each(items, (historyItem, i) => {
                historyItem.snapshotTime = moment(historyItem.snapshotTime);

                const formattedJson = JSON.stringify(
                    JSON.parse(historyItem.snapshotItemJson),
                    null,
                    2
                );
                historyItem.snapshotItemJson = formattedJson;

                const isLastItem = i === items.length - 1;
                const origJson = isLastItem
                    ? ''
                    : JSON.stringify(JSON.parse(items[i + 1].snapshotItemJson), null, 2);
                
                historyItem.showDiff = historyItem.snapshotItemJson !== origJson;

                if (historyItem.showDiff) {
                    items[i].codeMirrorOptions = $.extend({}, codeMirrorOptions, {
                        orig: origJson,
                    });
                }
            });
        }
    }

})();